// extracted by mini-css-extract-plugin
module.exports = {"navlink":"navbar_navlink__2XaTE","selected":"navbar_selected__3pt6M","container":"navbar_container__3ZsTe"};